import TemplateView from '../../../../../../js/TemplateView'

export default class ExportICalLightBoxHeader extends TemplateView {
    getCloseButtonEl() {
        return this.find('.closeButton')
    }

    templateHtml() {
        return `<div class='dialog-header iCalLightBoxHeader exportICalLightBoxHeader'>
                    <div class='closeButton'/>
                    <div class='lightBoxTitle'>
                        <%=title%>
                    </div>
                </div>`
    }

    messageKeys() {
        return {
            title: 'icalendar.page.lightbox.export.title'
        }
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/lightbox/export/ExportICalLightBoxHeader.js